import { MotifButton, MotifCard, MotifFooter, MotifIcon, MotifProgressIndicator, MotifProgressIndicatorStep } from '@ey-xd/motif-react';
import { MotifButtonGroup } from '@ey-xd/motif-react/components/button';
import { MotifCardBody } from '@ey-xd/motif-react/components/card';
import React, { useCallback, useEffect, useState } from 'react'
import ReportsUploadTemplate from './ReportsUploadTemplate';
import ReportDocPreview from './ReportDocPreview';
import { useDispatch, useSelector } from 'react-redux';
import ReportEditTemplate from './ReportEditTemplate';
import iconSvg from "../../assets/icons/icon.svg.json";

const AddUpdateReport = (props: any) => {
  const { onCancel, isEdit } = props;
  const { workspaceOverview, workspaceReportPreview } = useSelector((state: any) => state.workspaces);
  const [addReportProgress, setAddReportProgress] = React.useState(isEdit ? 2 : 1);
  const [file, setFile] = useState<any>(undefined);
  const dispatch = useDispatch();  
  const changeProgressStep = (step) => {
    setAddReportProgress(step);
  }

  const handleUpload = () => {
    dispatch({
      type: 'WORKSPACE_ADD_NEW_REPORT',
      payload: {
        file: file[0],
        workspaceId: workspaceOverview.workSpaceId
      }
    });
    onCancel()
  };

  const onSubmit = () => {
    dispatch({
      type: 'WORKSPACE_SAVE_NEW_REPORT',
      payload: {
        ...(workspaceReportPreview ?? {})
      }
    });
  };

  useEffect(() => {
    if(addReportProgress === 2 && !isEdit) {
      handleUpload();
    }
  }, [addReportProgress, file, isEdit])

  const header = useCallback(() => {
    return (
      <div className="flex gap-5 justify-between items-center">
        <div onClick={onCancel} className="flex gap-1 items-center cursor-pointer">
          <MotifIcon src={iconSvg["arrow-left"]} className="!w-6 !py-3" />
          <h4 className='!py-3 !font-bold'>
            Back to list
          </h4>
        </div>
        <div className="!w-full max-w-[700px]">
          <MotifProgressIndicator
            className="!w-full"
            hideIcon
            size="sm"
            variant="row"
          >
            <MotifProgressIndicatorStep
              body="Browse or drag & drop file"
              heading="Upload RFP"
              // onClick={() => changeProgressStep(1)}
              status={addReportProgress === 1 ? "active" : addReportProgress > 1 ? "completed" : "default"}
            />
            <MotifProgressIndicatorStep
              body="Fill in placeholders in your template"
              heading="RFP Response"
              // onClick={() => changeProgressStep(2)}
              status={addReportProgress === 2 ? "active" : addReportProgress >= 2 ? "completed" : "default"}
            />
            {/* <MotifProgressIndicatorStep
              body="View your report and confirm"
              heading="Preview"
              onClick={() => changeProgressStep(3)}
              status={addReportProgress === 3 ? "active" : addReportProgress > 2 ? "completed" : "default"}
            /> */}
          </MotifProgressIndicator>
        </div>
      </div>
    )
  }, [addReportProgress])

  const stepsContainer = useCallback(() => {
    return (
      <MotifCard>
        <MotifCardBody className="!min-h-[40vh]">
          {addReportProgress === 1 && <ReportsUploadTemplate file={file} setFile={setFile} />}
          {addReportProgress === 2 && <ReportEditTemplate {...(workspaceReportPreview ?? {})} />}
          {addReportProgress === 3 && <ReportDocPreview aiGeneratedOutput={workspaceReportPreview?.aiGeneratedOutput} historicalOutput={workspaceReportPreview?.historicalOutput} fileType="pptx" />}
        </MotifCardBody>
      </MotifCard>
    )
  }, [addReportProgress, workspaceReportPreview, file])

  const footer = useCallback(() => {
    if(addReportProgress > 1) {
      return <></>
    }
    return (
      <MotifFooter className="!bg-[transparent]">
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <div
            style={{
              display: 'flex',
              gap: '16px'
            }}
          >
            <MotifButton onClick={onCancel} variant="secondary">
              Cancel
            </MotifButton>
            {/* {addReportProgress > 1 && (
            <MotifButton variant="secondary" onClick={() => changeProgressStep(addReportProgress - 1)}>
              Previous
            </MotifButton>  
            )} */}
            {addReportProgress < 2 && (
            <MotifButton disabled={!file} onClick={() => changeProgressStep(addReportProgress + 1)}>
              Next
            </MotifButton>
            )}
            {/* {addReportProgress === 2 && (
              <MotifButton variant="primary" onClick={onSubmit}>
                Submit
              </MotifButton>
            )} */}
          </div>
        </div>
      </MotifFooter>
    )
  }, [addReportProgress, file, workspaceReportPreview])

  return (
    <div className="flex flex-col gap-5">
      {header()}
      {stepsContainer()}
      {footer()}
    </div>
  )
}

export default AddUpdateReport